module.exports = __webpack_public_path__ + "img/7.6559256a.svg";